import { describeError } from '@f/error-decorators';

export function getToastTemplate(action = {}) {
  if (action.error) {
    const describedError = describeError(action.payload);
    const { payload } = describedError.data;

    if (!payload.toast) {
      return null;
    }

    return payload;
  }

  if (!action.showNotification) {
    return null;
  }
}
